module.exports = __webpack_public_path__ + "img/312.cf9ff017.png";